import styled from 'styled-components';

export const ReportingResetFailContainer = styled.div`
  background-color: ${(props) => props.theme.newPalette.turquoise.T100};
`;
